//
//
//
//
//
//
//
//
//
//
//
//
//
//

// textarea 换行切割成数组
const richSplit = v => {
  return v ? v.split(/[(\r\n)\r\n]+/) : []
}

export default {
  name: "VocTextarea",
  props: {
    value: {
      type: String,
      default: ""
    },
    // 只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 每行限制输入字符个数
    // 为 0 的时候不限制每行输入
    rowLimit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      content: ""
    }
  },
  created() {
    this.content = this.value
  },
  watch: {
    value(v) {
      this.content = v
    }
  },
  methods: {
    onValueInput(v) {
      if (this.rowLimit > 0) {
        // const ref = this.$refs["voc-textarea"].$el.querySelector("textarea")
        const vSplitted = richSplit(v)
        this.content = vSplitted.map(item => item.slice(0, this.rowLimit)).join("\r\n")
      } else {
        // 没有限制每行输入字符数
        this.content = v
      }

      this.$emit("voc-textarea-value-changed", this.content)
    }
  }
}
